import script from "./TabbarSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./TabbarSwitch.vue?vue&type=script&setup=true&lang=js"

import "./TabbarSwitch.vue?vue&type=style&index=0&id=2830793e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2830793e"]])

export default __exports__